import { render, staticRenderFns } from "./AllPurposeLoans.vue?vue&type=template&id=2f384de6&scoped=true"
import script from "./AllPurposeLoans.vue?vue&type=script&lang=js"
export * from "./AllPurposeLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f384de6",
  null
  
)

export default component.exports